export const state = {
  interchanges: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/interchanges/state.js